import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
// @ts-expect-error untyped
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const UserValueComponent = ({
  count
}) => {
  if (count > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.teamMembersValues",
      options: {
        count
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.teamMembers"
  });
};
const TeamMemberFilter = ({
  selectedUsers,
  onChange
}) => {
  const userResolver = createStandardCachedResolver(USER);
  return /*#__PURE__*/_jsx(ReferenceLiteSearchSelect, {
    ButtonContent: UserValueComponent,
    buttonContentProps: {
      count: selectedUsers.length
    },
    buttonUse: "transparent",
    "data-test-id": "team-members-select",
    menuWidth: 300,
    minimumSearchCount: 3,
    multi: true,
    onChange: evt => {
      const newSelectedUsers = evt.target.value.map(id => Number(id));
      onChange === null || onChange === void 0 || onChange(newSelectedUsers);
    },
    resolver: userResolver,
    value: selectedUsers.map(id => String(id))
  });
};
export default TeamMemberFilter;